import { Role } from "./role.model";

export interface User {
  // Base entity fields
  id: string;
  remarks?: string | null;
  is_deleted: boolean;
  created_by?: string | null;
  created_on: Date;
  last_modified_by?: string | null;
  last_modified_on: Date;

  // User specific fields
  email: string;
  first_name: string;
  last_name: string;
  picture_url?: string | null;
  affiliation_code_id?: string | null;
  representative_id?: string | null;
  enable_two_factor: boolean;
  access_failed_count: number;
  is_beta_user: boolean;
  date_of_birth?: Date | null;
  gender?: Gender | null;
  bio?: string | null;
  country_id?: string | null;
  city_id?: string | null;
  phone?: string | null;
  whatsapp?: string | null;
  stripe_customer_id?: string | null;
  status: UserStatus;
  timezone_offset: number;

  // Virtual properties (if needed)
  full_name?: string;
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING_VERIFICATION',
  SUSPENDED = 'SUSPENDED'
}

// If you need to keep the organization roles, you can keep these interfaces
export interface OrganizationRole {
  id: string;
  user_id: string;
  organization_id: string;
  role_id: string;
  status: OrganizationRoleStatus;
  created_on: Date;
  last_modified_on: Date;
}

export enum OrganizationRoleStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING'
}

// If you need notification preferences, you can keep this interface
export interface NotificationPreferences {
  email_notifications: boolean;
  push_notifications: boolean;
  login_alerts: boolean;
  organization_updates: boolean;
  marketing_emails: boolean;
}

// Helper function to get full name (optional)
export function getFullName(user: User): string {
  return `${user.first_name} ${user.last_name}`.trim();
}
